import { useEffect} from 'react';
import { setTokenInSessionStorage } from '~/keycloack/authentication';
import { refreshAccessToken } from '~/services/keycloak';
import { SCRIPTS_PATH } from '~/services/endpoints';
import { buildLogoutUrl } from '../../services/keycloak';
import useSessionTimeout from '~/services/session/SessionTimeOut';
import { Scripts } from './Scripts';


const VerifiedScriptPage = () => {
  const INACTIVITY_LIMIT = Number(import.meta.env.VITE_INACTIVITY_LIMIT) || 5 * 60 * 1000; // Default: 5 minutes
  const FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN = Number(import.meta.env.VITE_FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN) || 30 * 60 * 1000; // Default: 30 minutes
  const REFRESH_INTERVAL = 4 * 60 * 1000; // 4 minutes


  /**
   * Refreshes the access token periodically.
   */
/**
 * Refreshes the access token periodically.
 */
async function handleTokenRefresh() {
  const refreshToken = sessionStorage.getItem('refresh_token');
    if (refreshToken) {
    try {
      const data = await refreshAccessToken(
        refreshToken,
        `${window.location.origin}${SCRIPTS_PATH}`
      );

      if ('access_token' in data) {
        setTokenInSessionStorage(
          data.access_token,
          data.refresh_token,
          data.expires_in.toString()
        );
        sessionStorage.setItem('id_token', data.id_token);
      } else {
        console.error('Token refresh failed:', data.error || 'No access token in response');
        // Optionally trigger logout
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
      // Optionally trigger logout
    }
  }
}


  /**
   * Set up session timeout handling.
   */
  useSessionTimeout({
    inactivityLimit: INACTIVITY_LIMIT,
    forcedLogoutLimit: FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN,
    buildLogoutUrl,
    storage: sessionStorage,
  });


  /**
   * Set up token refresh interval.
   */
  useEffect(() => {
    const interval = setInterval(() => {
      handleTokenRefresh();
    }, REFRESH_INTERVAL);
    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, [handleTokenRefresh]);

  
  /**
   * Render Scripts component within PrivateRoute.
   */
  return (
    <Scripts/> 
  );
};

export default VerifiedScriptPage;